var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo27(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 80,
    viewBox: "0 0 57 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M.424 15.873l5.11 57.456 22.931 6.38 22.995-6.388 5.116-57.448H.424zm43.833 32.056l-1.488 13.9.006 1.19L28.5 67.016l-.011.01-14.39-3.952-.973-11.01h7.056l.5 5.565 7.82 2.092-.002.01v-.02l7.85-2.22.828-9.237H20.77l-.14-1.495-.32-3.586-.169-1.903h17.661l.643-6.984h-26.9l-.141-1.644-.32-3.829-.168-2.146h35.21l-.168 2.116-1.7 19.146z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1572B6",
    d: "M44.333 8.491l-4.527-5.316h4.527V0H34.2v2.77l5.314 4.849H34.2v3.175h10.133V8.49zm-12.033 0l-4.311-5.316H32.3V0h-9.5v2.77l4.898 4.849H22.8v3.175h9.5V8.49zM20.9 7.62h-5.067V3.175H20.9V0h-8.867v10.794H20.9V7.619z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo27);
export default __webpack_public_path__ + "static/media/logo27.17473340d40423c5bba64f452aa020d3.svg";
export { ForwardRef as ReactComponent };